module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.t('Shop')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.t('Seller')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.t('Name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Price')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Previous price')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Price percent diff')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Date start of drop price')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.shop_name))]), _vm._v(" "), _c('td', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.seller_name),
        expression: "item.seller_name"
      }]
    }, [_vm._v(_vm._s(item.seller_name))])]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank",
        "rel": "noreferrer"
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.prev_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.price_percent_diff) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.price_down_begin_at))])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c133256!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WhoFirstDropPrice.vue
// module id = 1274
// module chunks = 2